export var REQUIRED_CSV_FILE_HEADERS = ['username', 'lastName', 'firstName', 'email', 'groups'];
export var FILE_ACCEPTED_TYPES = ['text/csv', 'application/vnd.ms-excel'];
export var MAX_USER = 200;
